import React, { useState } from "react";
import { SliderPanel } from "../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDoubleRight,
  faFileInvoiceDollar,
  faPenSquare,
  faTimes,
  faTrashAlt,
} from "@fortawesome/pro-light-svg-icons";
import { Button, InputGroup } from "react-bootstrap";
import SearchBar from "../../Mapper/LoadDefHomeContainer/SearchBar";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useDeepEffect } from "../../../abstracts";

const InvestmentCardRight = (props) => {
  const { data, removeInvestment } = props;

  return (
    <div className="investment-card-add">
      <div className="d-flex flex-row justify-content-between investment-card-add-top">
        <div>{data.cusip}</div>
        <div className="small-text d-flex flex-row">
          <p
            className=""
            onClick={() => removeInvestment(data.investmentId)}
            style={{
              fontSize: "12px",
              fontWeight: "400",
              marginRight: "5px",
              color: "#C4061A",
              marginBottom: "0px",
              cursor: "pointer",
            }}
          >
            Click to remove
          </p>
          <FontAwesomeIcon
            className="primary-small"
            icon={faTimes}
            style={{
              fontSize: "12px",
              fontWeight: "400",
              color: "#C4061A",
              paddingTop: "3px",
            }}
          />
        </div>
      </div>
      <div className="investment-card-add-bottom ft-16 fw-600">{data.name}</div>
    </div>
  );
};
export default InvestmentCardRight;
